import { RepositoryFactory } from '@/repositories/RepositoryFactory';
const BrandRepository = RepositoryFactory.get('brands');
import { v4 as uuidv4 } from 'uuid';
import Brand from '../models/Brand';

export class BrandService {
  static async getBrands(params) {
    try {
      const response = await BrandRepository.get(params);
      return {
        brands: Brand.fromApiResponseArray(response.brands),
        totalItems: response.totalItems,
        totalPages: response.totalPages,
        currentPage: response.currentPage,
      };
    } catch (error) {
      console.error('Lỗi khi tải thương hiệu:', error);
      throw error;
    }
  }

  static async createBrand(name) {
    const brand = new Brand({
      id: uuidv4(),
      name: name.trim(),
    });

    if (!brand.isValid) {
      throw new Error('Tên thương hiệu không được để trống');
    }

    try {
      return await BrandRepository.create(brand.toJSON());
    } catch (error) {
      console.error('Lỗi khi tạo thương hiệu:', error);
      throw error;
    }
  }

  static async updateBrand(id, name) {
    if (!id) {
      throw new Error('ID thương hiệu không hợp lệ');
    }

    if (!name || name.trim() === '') {
      throw new Error('Tên thương hiệu không được để trống');
    }

    try {
      return await BrandRepository.update(id, { name: name.trim() });
    } catch (error) {
      console.error('Lỗi khi cập nhật thương hiệu:', error);
      throw error;
    }
  }

  static async deleteBrand(id) {
    if (!id) {
      throw new Error('ID thương hiệu không hợp lệ');
    }

    try {
      return await BrandRepository.delete(id);
    } catch (error) {
      console.error('Lỗi khi xóa thương hiệu:', error);
      throw error;
    }
  }
}
